// extracted by mini-css-extract-plugin
export default {"button":"LoadingIcon_button__ONcdT"};